import React from "react"
import { Helmet } from "react-helmet"

import type { OrganizationSchemaProps } from "../../types/schema"

/**
 * OrganizationSchema component for adding Organization structured data (JSON-LD)
 * This helps search engines and AI understand your brand, social profiles,
 * and contact information.
 *
 * Should be added to the site layout or homepage.
 *
 * @see https://schema.org/Organization
 */
export const OrganizationSchema: React.FC<OrganizationSchemaProps> = ({
  contactPoint,
  description = "Urban Armor Gear produces the most rugged, lightweight cases that are drop tested to US Military Specs. Made for iPhones, iPads, MacBooks, Galaxy, & Surface.",
  foundingDate,
  logo = "https://www.urbanarmorgear.com/logo.png",
  name = "Urban Armor Gear",
  sameAs = [
    "https://www.facebook.com/urbanarmorgear",
    "https://www.instagram.com/urbanarmorgear",
    "https://twitter.com/urbanarmorgear",
    "https://www.youtube.com/urbanarmorgear",
  ],
  url = "https://www.urbanarmorgear.com",
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    logo,
    name,
    url,
    ...(description && { description }),
    ...(foundingDate && { foundingDate }),
    ...(sameAs && sameAs.length > 0 && { sameAs }),
    ...(contactPoint && { contactPoint }),
  }

  return (
    <Helmet as={React.Fragment as any}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}
